import { Alert, Box } from '@mui/material';
import React from 'react';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const EarlyAccessBanner = () => {
  return (
    <Box>
      <Alert severity="info" icon={<RocketLaunchIcon />}>
        This feature is currently in early access and will be added to{' '}
        <strong>Restorize Add-Ons</strong> in the future.
      </Alert>
    </Box>
  );
};

export default EarlyAccessBanner;
